package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.*

class AdminRepository(private val httpClient: HttpClient) {
    suspend fun getOverview(): Result<AdminOverviewDto> = runCatching {
        httpClient.get("admin/overview").body()
    }

    suspend fun getOrgs(): Result<List<AdminOrgDto>> = runCatching {
        httpClient.get("admin/orgs").body()
    }

    suspend fun getUsers(): Result<List<AdminUserDto>> = runCatching {
        httpClient.get("admin/users").body()
    }

    suspend fun setUserActive(userId: Long, active: Boolean): Result<Unit> = runCatching {
        httpClient.put("admin/users/$userId/active") {
            contentType(ContentType.Application.Json)
            setBody(SetActiveRequest(active))
        }
    }

    suspend fun setOrgPlanStatus(orgId: Long, planStatus: String): Result<Unit> = runCatching {
        httpClient.put("admin/orgs/$orgId/plan") {
            contentType(ContentType.Application.Json)
            setBody(SetPlanStatusRequest(planStatus))
        }
    }

    suspend fun updateOrg(orgId: Long, req: AdminUpdateOrgRequest): Result<Unit> = runCatching {
        httpClient.put("admin/orgs/$orgId") {
            contentType(ContentType.Application.Json)
            setBody(req)
        }
    }

    suspend fun deleteOrg(orgId: Long): Result<Unit> = runCatching {
        httpClient.delete("admin/orgs/$orgId")
    }

    suspend fun updateUser(userId: Long, req: AdminUpdateUserRequest): Result<Unit> = runCatching {
        httpClient.put("admin/users/$userId") {
            contentType(ContentType.Application.Json)
            setBody(req)
        }
    }

    suspend fun deleteUser(userId: Long): Result<Unit> = runCatching {
        httpClient.delete("admin/users/$userId")
    }
}
